import LocationStatistics from "@spa/features/search_job/pc/components/knowledge_panel/location_statistics/LocationStatistics";
import KeywordDescription from "@spa/features/search_job/pc/components/knowledge_panel/keyword_description/KeywordDescription";

const KnowledgePanel = ({searchResultViewModel}) => {
    const knowledgePanelViewModel = searchResultViewModel.knowledgePanelViewModel;

    // データ整理
    const locationStatisticsData = knowledgePanelViewModel.locationStatistics;
    const keywordDescriptionData = knowledgePanelViewModel.keywordDescription;
    const chartData = knowledgePanelViewModel.chartData;

    // 不足データを補充
    locationStatisticsData.locationWord = searchResultViewModel.locationWord;
    keywordDescriptionData.hitCount = searchResultViewModel.hitCount;
    keywordDescriptionData.locationWord = searchResultViewModel.locationWord;
    keywordDescriptionData.keywordOfSearchResultViewModel = searchResultViewModel.keyword;

    return (
        <div className="p-knowledge_wrap">
            {knowledgePanelViewModel.isDisplayableStatistics &&
                <LocationStatistics
                    locationStatistics={locationStatisticsData}
                    chartData={chartData}
                />
            }
            {knowledgePanelViewModel.isDisplayableKeywordDescription &&
                <KeywordDescription
                    keywordDescription={keywordDescriptionData}
                />
            }
        </div>
    );
}

export default KnowledgePanel;
